// Project pipelines configuration
export const PROJECT_PIPELINES = {
  // Human Perfect pipeline
  HUMAN_PERFECT: {
    name: "Human Perfect",
    statuses: ["Not_Started", "First_Review", "QA_Review", "Compliance", "Publication"],
    statusMap: {
      "Not_Started": "Not Started",
      "First_Review": "First Review",
      "QA_Review": "Speaker Verified",
      "Compliance": "First Draft Final",
      "Publication": "Human Perfect",
    },
    verificationSteps: {
      "First_Review": "SPEAKER_VERIFICATION",
      "QA_Review": "FULL_FIRST_DRAFT",
      "Compliance": "FULL_HUMAN_PERFECT",
    }
  },
  // First Draft pipeline
  FIRST_DRAFT: {
    name: "First Draft",
    statuses: ["Not_Started", "First_Review", "QA_Review", "Compliance"],
    statusMap: {
      "Not_Started": "Not Started",
      "First_Review": "First Review",
      "QA_Review": "Speaker Verified",
      "Compliance": "First Draft Final",
    },
    verificationSteps: {
      "First_Review": "SPEAKER_VERIFICATION",
      "QA_Review": "FULL_FIRST_DRAFT",
    }
  },
  // Default pipeline
  DEFAULT: {
    name: "Default",
    statuses: ["Not_Started", "First_Review", "QA_Review", "Compliance", "Publication"],
    statusMap: {
      "Not_Started": "Not Started",
      "First_Review": "First Review",
      "QA_Review": "QA Review",
      "Compliance": "Final Review",
      "Publication": "Submitted",
    }
  },
};

// Default pipeline
export const DEFAULT_PIPELINE = "FIRST_DRAFT";

// Get pipeline type based on upload_type
export const getPipelineTypeFromUploadType = (uploadType) => {
  // Map upload_type to pipeline types
  const uploadTypeToPipeline = {
    'HUMAN': 'HUMAN_PERFECT',
    'FIRST_DRAFT': 'FIRST_DRAFT',
    'AI': 'DEFAULT',
    'REALTIME': 'DEFAULT',
    'HIRING': 'HIRING',
    'DEFAULT': 'DEFAULT',
    // Add more mappings as needed
  };

  return uploadTypeToPipeline[uploadType] || DEFAULT_PIPELINE;
};

// Get the current pipeline from localStorage or use default
export const getCurrentPipeline = () => {
  const storedPipeline = localStorage.getItem("currentProjectPipeline");
  return storedPipeline ? storedPipeline : DEFAULT_PIPELINE;
};

// Get statuses for the current pipeline
export const getCurrentPipelineStatuses = () => {
  const currentPipeline = getCurrentPipeline();
  return PROJECT_PIPELINES[currentPipeline]?.statuses || PROJECT_PIPELINES[DEFAULT_PIPELINE].statuses;
};

// Get next status in the current pipeline
export const getNextStatus = (currentStatus) => {
  const statuses = getCurrentPipelineStatuses();
  const index = statuses.findIndex((value) => value === currentStatus);

  if (index > -1 && index < statuses.length) {
    const nextIndex = ((index + 1) >= statuses.length) ? (statuses.length - 1) : (index + 1);
    return statuses[nextIndex];
  }

  return statuses[0];
};

// Get pipeline from workflow data
export const getPipelineFromWorkflow = (workflowData) => {
  // Use upload_type to determine pipeline if available
  if (workflowData?.upload_type) {
    const pipelineFromUploadType = getPipelineTypeFromUploadType(workflowData.upload_type);
    if (PROJECT_PIPELINES[pipelineFromUploadType]) {
      return pipelineFromUploadType;
    }
  }

  // Fallback to project_pipeline or default
  const pipelineName = workflowData?.project_pipeline || DEFAULT_PIPELINE;
  return PROJECT_PIPELINES[pipelineName] ? pipelineName : DEFAULT_PIPELINE;
};

// Get next status based on workflow data
export const getNextStatusFromWorkflow = (workflowData, currentStatus) => {
  const pipelineName = getPipelineFromWorkflow(workflowData);
  const statuses = PROJECT_PIPELINES[pipelineName].statuses;
  const index = statuses.findIndex((value) => value === currentStatus);

  if (index > -1 && index < statuses.length) {
    const nextIndex = ((index + 1) >= statuses.length) ? (statuses.length - 1) : (index + 1);
    return statuses[nextIndex];
  }

  return statuses[0];
};

// Check if the current status requires verification
export const requiresVerification = (workflowData, currentStatus) => {
  const pipelineName = getPipelineFromWorkflow(workflowData);
  const pipeline = PROJECT_PIPELINES[pipelineName];

  return pipeline?.verificationSteps && pipeline.verificationSteps[currentStatus];
};

// Get verification type for the current status
export const getVerificationType = (workflowData, currentStatus) => {
  const pipelineName = getPipelineFromWorkflow(workflowData);
  const pipeline = PROJECT_PIPELINES[pipelineName];

  return pipeline?.verificationSteps?.[currentStatus] || null;
};
